import { withStyles } from '@material-ui/core';
import SnackBar from './SnackBar';
import styles from './styles';

export default withStyles(styles)(SnackBar);
